import { useTranslation } from 'react-i18next';

function EmptyFieldLabel() {
  const { t } = useTranslation();

  return <p className="font-light text-sm text-gray-3 py-1">{t('none', 'None')}</p>;
}

export default EmptyFieldLabel;
